const Gender = Object.freeze({
  FEMALE: 'Female',
  MALE: 'Male',
  UNKNOWN: 'Unknown'
})
export default Gender
export type GenderStrings = typeof Gender[keyof typeof Gender]
// RESERVE BELOW
